export class ModuloPermesso {
  moduloId: number;
  licenzaId?: number;
  organizzazioneId: number;
  roleId: number;
  operatoreId: number;
  activationDate: Date;
  expiryDate: Date;
}
